import { useTranslation } from 'react-i18next'
import { ListDebts } from 'src/features/Debt/ListDebts'
import { Container, PageContainer } from '~/shared/ui/Layout'

export function ListDebtsPage() {
  const { t } = useTranslation()
  return (
    <PageContainer title={t('debts')}>
      <Container>
        <ListDebts />
      </Container>
    </PageContainer>
  )
}
